import React from 'react'

/**
 * Grid component for layout
 * @param {Object} props - Component props
 * @param {React.ReactNode} props.children - Grid content
 * @param {string} props.className - Additional CSS classes
 * @param {number} props.cols - Number of columns (1-12)
 * @param {string} props.gap - Gap size (sm, md, lg)
 */
const Grid = ({ children, className = '', cols = 3, gap = 'md', ...rest }) => {
  // Base styles
  const baseStyles = 'grid grid-flow-dense'

  // Columns styles
  const colsMap = {
    1: 'grid-cols-1',
    2: 'grid-cols-1 sm:grid-cols-2',
    3: 'grid-cols-1 sm:grid-cols-2 lg:grid-cols-3',
    4: 'grid-cols-1 sm:grid-cols-2 lg:grid-cols-4',
    6: 'grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 lg:grid-cols-6',
    12: 'grid-cols-1 sm:grid-cols-3 lg:grid-cols-6 lg:grid-cols-12',
  }

  // Gap styles
  const gapMap = {
    sm: 'gap-2',
    md: 'gap-4',
    lg: 'gap-6',
  }

  return (
    <div
      className={`${baseStyles} ${colsMap[cols]} ${gapMap[gap]} ${className}`}
      {...rest}
    >
      {children}
    </div>
  )
}

export default Grid
